/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const compositeEntityDetailsMessages = defineMessages({
    featureSectionTitle: {
        id: 'entities.compositeEntityDetails.featureSectionTitle',
        defaultMessage: 'Features'
    },
    addFeatureSectionCallout: {
        id: 'entities.compositeEntityDetails.addFeatureSectionCallout',
        defaultMessage: 'It is a feature applied to a model at training time, including phrase lists and entities.'
    },
    childrenSectionTitle: {
        id: 'entities.compositeEntityDetails.childrenSectionTitle',
        defaultMessage: 'Children'
    },
    deleteChildModalTitle: {
        id: 'entities.compositeEntityDetails.deleteChildModalTitle',
        defaultMessage: 'Delete child/children?'
    },
    deleteChildModalDescription: {
        id: 'entities.compositeEntityDetails.deleteChildModalDescription',
        defaultMessage: 'Are you sure you want to delete this child/children?'
    },
    deleteChildToastStart: {
        id: 'entities.compositeEntityDetails.deleteChildToastStart',
        defaultMessage: 'Deleting child ...'
    },
    deleteChildrenToastStart: {
        id: 'entities.compositeEntityDetails.deleteChildrenToastStart',
        defaultMessage: 'Deleting children ...'
    },
    deleteChildToastSuccess: {
        id: 'entities.compositeEntityDetails.deleteChildToastSuccess',
        defaultMessage: 'Delete child completed'
    },
    deleteChildrenToastSuccess: {
        id: 'entities.compositeEntityDetails.deleteChildrenToastSuccess',
        defaultMessage: 'Delete children completed'
    },
    deleteChildToastFailed: {
        id: 'entities.compositeEntityDetails.deleteChildToastFailed',
        defaultMessage: 'Deleting child failed'
    },
    deleteChildrenToastFailed: {
        id: 'entities.compositeEntityDetails.deleteChildrenToastFailed',
        defaultMessage: 'Deleting children failed'
    },
    createChildToastFailed: {
        id: 'entities.compositeEntityDetails.createChildToastFailed',
        defaultMessage: 'Creating child failed'
    },
    createChildToastSuccess: {
        id: 'entities.compositeEntityDetails.createChildToastSuccess',
        defaultMessage: 'Creating child completed'
    },
    createChildToastStart: {
        id: 'entities.compositeEntityDetails.createChildToastStart',
        defaultMessage: 'Creating child ...'
    }
});
